export const adaptRegion = (data: IRegion): LocationRegion => {
	return {
		id: data.id,
		name: data.name,
		regionManager: data.region_manager,
		lastsync: data.lastsync,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptRegions = (data: IRegion[]): LocationRegion[] => {
	return data.map(adaptRegion);
};
